import { useState, useEffect } from 'react';
import { db } from '../../firebase';
import { collection, getDocs, addDoc, deleteDoc, doc } from 'firebase/firestore';
import { defaultTemplates } from '../../utils/scenarioBuilder/defaultTemplates';

export const useScenarioTemplates = () => {
  const [templates, setTemplates] = useState([]);
  const [listLoading, setListLoading] = useState(false);
  const [importing, setImporting] = useState(false);

  const fetchTemplates = async () => {
    setListLoading(true);
    try {
      const snap = await getDocs(collection(db, 'scenarioTemplates'));
      const templateData = snap.docs.map(doc => ({ id: doc.id, ...doc.data() }));
      setTemplates(templateData);
      return templateData; // Return the data for potential chaining
    } catch (error) {
      console.error('Error fetching templates:', error);
      return [];
    } finally {
      setListLoading(false);
    }
  };

  const deleteTemplate = async (id) => {
    try {
      await deleteDoc(doc(db, 'scenarioTemplates', id));
      setTemplates(templates => templates.filter(t => t.id !== id));
    } catch (error) {
      console.error('Error deleting template:', error);
    }
  };

  const importTemplates = async () => {
    setImporting(true);
    try {
      const existing = (await getDocs(collection(db, 'scenarioTemplates'))).docs.map(doc => doc.data().name);
      for (const t of defaultTemplates) {
        if (!existing.includes(t.name)) {
          await addDoc(collection(db, 'scenarioTemplates'), t);
        }
      }
      await fetchTemplates();
      alert('Default templates imported!');
    } catch (error) {
      console.error('Error importing templates:', error);
      alert('Error importing templates');
    } finally {
      setImporting(false);
    }
  };

  useEffect(() => {
    fetchTemplates();
  }, []);

  return {
    templates,
    listLoading,
    importing,
    fetchTemplates,
    deleteTemplate,
    importTemplates
  };
};
